import React from 'react';
import {
  Image,
  Stack,
  VStack,
  Container,
  Flex,
  useBreakpointValue,
  Heading,
} from '@chakra-ui/react';

import HomeLayout from '../../components/layouts/homelayout';
import TextWithRightMedia from '../../components/sections/textwithrightmedia';
import TextWithLeftMedia from '../../components/sections/textwithleftmedia';

import InclusionDiversityHero from '../../components/ui/ourcompany/S18-Montrail-TK-1187-copy-crop1651x903.png'
import InclusionDiversitySelfie from '../../components/ui/ourcompany/S19_CAS_BR_OR_0068-copy.jpeg'
import GertImg from '../../components/ui/ourcompany/gert_boyle.jpeg'

export default function GlobalCulture() {
  return (
    <HomeLayout align="left">
      <title>Diversity, Equity, & Inclusion</title>
      <meta name="description" content="We connect active people with their passions across race, ethnicity, gender, ability, religion and sexual orientation." />
      <Stack w="full" className='page-banner'></Stack>
      <Flex
        w={'full'}
        h={'60vh'}
        backgroundImage={`url(${InclusionDiversityHero})`}
        backgroundSize={'cover'}
        backgroundPosition={'center center'}
        id="strategyMissionValuesHeroImg"
      >
        <VStack
          w={'full'}
          justify={'flex-end'}
          align={'left'}
          pb={useBreakpointValue({ base: 4, md: 12 })}
          bgGradient='to-r'
          gradientFrom={'blackAlpha.600'}
          gradientTo={'transparent'}
        >
          <Container maxW={'6xl'}>
            <Heading
              as={'h1'}
              color={'white'}>
              The Outdoors is for Everyone
            </Heading>
          </Container>
        </VStack>
      </Flex>
      <Container maxW={'6xl'}>
      <TextWithRightMedia
        title={<h2>Global Culture</h2>}
        content={<>
            <p>
                The outdoors thrives because of its diversity — different colors, shapes, and species creating ecosystems that are stronger together than they could ever be alone. People and organizations flourish the same way. When we bring together a wide range of worldviews, experiences, and ways of seeing the world, we unlock creativity, innovation, and a deeper sense of connection. 
            </p>
            <p>
                From our roots as a family business to our growth into a global company, we’ve learned that belonging is essential to progress. Since 1938, we’ve been making clothing and footwear so more people can enjoy the outdoors in ways that feel true to them. 
            </p>
            <p>
                We’re committed to fostering a culture where every perspective is valued and where people feel invited to contribute, collaborate, and grow. Doing right by our consumers, customers, employees, and communities is one of our core values — and it guides how we show up every day. 
            </p>
            <p>
                At the heart of it all is a simple belief: the outdoors is for everyone. When people feel welcome and connected, we all go further. 
            </p>
        </>}
        media={<Image src={InclusionDiversitySelfie} />}
      />
      <TextWithLeftMedia
        title={<h2>Our History Informs Our Present</h2>}
        content={
          <p>
            Columbia Sportswear Company was founded by immigrants fleeing Nazi
            Germany. Their daughter, Gert Boyle, held every position, from
            seamstress of the first fishing vest to President and Chair of the
            Board. Ma Boyle was a pioneer as a woman in the outdoor industry.
            Her legacy continues to inspire us now that we are a global company
            with more than 7,000 employees all over the world.
          </p>
        }
        media={<Image src={GertImg} />}
      />
      </Container>
    </HomeLayout>
  );
}
